﻿//We have a video inside of a modal. When the user closes the modal, it should determine if the video is playing and if so, stop it.
//We also play the video when the 'play video' button is clicked. No point in forcing user to click twice to play a video.

function initAboutHeaderVideoModal() {
    const videoFrame = document.getElementById('embedded480Video');
    $('#headerVideoModal').on('shown.bs.modal', function (e) {
        videoFrame.src = 'https://www.youtube.com/embed/2ysLh4dYKZI';
    });
    $('#headerVideoModal').on('hide.bs.modal', function (e) {
        videoFrame.src = '';
    });
}

initAboutHeaderVideoModal();